import axios from "axios";

// create axios instance for all env
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Add an interceptor to set the authorization token for each request
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token"); // Get the token from localStorage

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    // ensure credentials (cookies) are sent with requests when needed
    config.withCredentials = true;
  }
  return config;
});

export default instance;